import { useState, FC } from "react";
import { default as PhoneInputReact } from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { styled } from "@mui/material";

type Props = {
  formik: any;
  name: string;
  keyProp: string;
  country: string;
  countries: string[];
};

const PhoneInput: FC<Props> = ({ name, countries, country, formik, keyProp }) => {
  const [phoneValue, setPhoneValue] = useState<string>("");

  const validatePhone = () => {
    let phoneValue = "";
    if (!formik?.values?.phone?.value?.includes("+")) {
      phoneValue = `+57${formik.values[name]?.value}`;
    }
    return phoneValue;
  };

  if (!formik?.values) return <></>;
  return (
    <>
      <PhoneInputStyled
        country={country}
        onlyCountries={countries}
        countryCodeEditable={false}
        value={phoneValue || validatePhone()}
        onBlur={formik.handleBlur}
        inputProps={{
          id: { name },
          name: { name },
          error: formik.errors[name],
        }}
        onChange={(value: string, { [keyProp]: keyValue }: any) => {
          setPhoneValue(value);
          formik.setFieldValue(name, {
            value,
            [keyProp]: keyValue,
          });
        }}
      />
      {formik.errors[name]?.value ? <ErrorMessage>{formik.errors[name].value}</ErrorMessage> : null}
    </>
  );
};

export default PhoneInput;

const PhoneInputStyled = styled(PhoneInputReact)`
  margin-top: 0.75rem;
  .flag-dropdown,
  .form-control {
    border-color: ${({ theme, inputProps }: any) => inputProps?.error && theme.error.danger};
  }

  :hover {
    .flag-dropdown,
    .form-control {
      border-color: ${({ theme, inputProps }: any) =>
        inputProps?.error ? theme.error.danger : theme.palette.primary.main};
    }
  }
  &:focus-within {
    .flag-dropdown,
    .form-control {
      border-color: ${({ theme, inputProps }: any) =>
        inputProps?.error ? theme.error.danger : theme.palette.primary.main};
    }
  }
  .form-control {
    width: 100% !important;
    height: 3.5em !important;
    font: inherit;
    letter-spacing: inherit;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    font-size: 1rem !important;
    line-height: 1.4375em;
    letter-spacing: 0.00938em;
  }
  .flag-dropdown {
    width: 10%;
  }
  .selected-flag {
    width: 58px !important;
    padding: 0 0 0 17px !important;
  }
  .react-tel-input,
  .form-control {
    padding-left: 70px !important;
  }
`;

const ErrorMessage = styled("p")`
  color: ${({ theme }) => theme.error.danger};
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  margin-top: 3px;
  margin-right: 14px;
  margin-bottom: 0;
  margin-left: 14px;
`;
